// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1bWu4","search":"Settings_search__r6dOR","filter":"Settings_filter__3AKA4"};